"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = void 0;
function pipe(previous) {
    return {
        if: function (condition) {
            if (condition) {
                return {
                    then: (newValue) => 
                    // if a callback is passed, callback is executed with previous value
                    newValue instanceof Function
                        ? pipe(newValue(previous))
                        : pipe(newValue)
                };
            }
            else {
                return {
                    then: () => pipe(previous)
                };
            }
        },
        then: (newValue) => newValue instanceof Function ? pipe(newValue(previous)) : pipe(newValue),
        valueOf: function () {
            return previous;
        }
    };
}
exports.pipe = pipe;
//# sourceMappingURL=pipe.js.map